<template>
    <div>
        <PageHeader>
            {{ $t('webhooks') }}
        </PageHeader>

        <b-modal
            :id="`modal-form-${modalId}`"
            ref="modal"
            :title="modalTitle"
            size="md"
            cancel-variant="light"
            ok-variant="primary"
            :cancel-title="$t('cancel')"
            :ok-title="$t('next')"
            :busy="submitting"
            static
            @ok.prevent="handleSubmit()"
        >
            <b-overlay :show="submitting" opacity="0" class="h-100">
                <b-form @submit.prevent>
                    <ErrorMessage :value="error" />

                    <FormValidator :validator="$v.form.webhook" form-group v-slot="slotProps" :label="$t('webhookUrl')">
                        <b-form-input v-model="form.webhook" :disabled="submitting" :state="slotProps.state" />
                    </FormValidator>
                </b-form>
            </b-overlay>
        </b-modal>

        <DataTable :items="items" :fields="fields" :loading="loading">
            <template #cell(action)="{ item }">
                <ButtonIcon size="sm" icon="edit-2" @click="triggerEdit(item)" />
            </template>
        </DataTable>
    </div>
</template>
<script>
    import DataTable from '@/components/common/DataTable.vue';
    import { url, required } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';

    export default {
        name: 'ProducerWebhooks',

        components: {
            DataTable,
            FormValidator,
        },
        data() {
            return {
                modalId: 'webhooks',
                form: {
                    webhook: '',
                },
                error: null,
                submitting: false,
                selectedSpace: null,
                request: this.$req('space/spaces'),
            };
        },
        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
            items() {
                return this.request.data?.items || [];
            },
            loading() {
                return this.request.loading;
            },
            fields() {
                return [
                    {
                        key: 'name',
                        label: this.$t('name'),
                        sortable: true,
                    },
                    {
                        key: 'webhook',
                        label: this.$t('webhookUrl'),
                    },
                    {
                        key: 'action',
                        label: '',
                        sortable: false,
                    },
                ];
            },
            modalTitle() {
                return this.$t('webhooks');
            },
        },
        validations() {
            return {
                form: {
                    webhook: { url, required },
                },
            };
        },
        methods: {
            async handleSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.submitting = true;

                await this.$store
                    .dispatch('space/updateSpace', {
                        id: this.selectedSpace.id,
                        webhook: this.form.webhook,
                    })
                    .catch(error => {
                        this.$toastr.error(error.message, this.$t('errorOccurred'));
                        this.error = error.message;
                        this.submitting = false;
                    })
                    .then(() => {
                        this.submitting = false;
                        this.fetchSpaces();
                        this.selectedSpace = null;
                        this.form.webhook = '';
                        this.$refs.modal.hide();
                    });
            },
            triggerEdit(space) {
                this.selectedSpace = structuredClone(space);
                this.form.webhook = space.webhook;

                this.$refs.modal.show();
            },
            fetchSpaces() {
                this.request.get(this.user.id).catch(error => {
                    this.$toastr.error(error.message, this.$t('errorOccurred'));
                });
            },
        },
        created() {
            this.fetchSpaces();
        },
    };
</script>
